export const RECEIVE_METER_GROUPS = 'RECEIVE_METER_GROUPS';
export const GET_METER_GROUPS = 'GET_METER_GROUPS';
export const SET_METER_GROUP = 'SET_METER_GROUP';
export const UPDATE_METER_GROUP = 'UPDATE_METER_GROUP';
export const DELETE_METER_GROUP = 'DELETE_METER_GROUP';
export const FETCH_METER_GROUPS = 'FETCH_METER_GROUPS';
